import { FC } from 'react';

import { FluidCard } from 'components/common/fluid-card';
import { AftercareFullLogo } from 'components/common/icons';
import { Tile } from 'components/common/tile';
import theme from 'utils/theme';

import { IAftercareTileProps } from './types';

export const AftercareTile: FC<IAftercareTileProps> = ({ genus }) => {
  return (
    <Tile
      url={`/aftercare/${genus.slug.current}`}
      title={genus.name}
      subtitle={genus.name && genus.botanicalName}
      image={genus.images?.[0]?.photos?.[0]}
      as="li"
    />
  );
};

export const AftercarePLPTile: FC<IAftercareTileProps> = ({
  genus,
  title,
  colorScheme = 'white:black',
}) => {
  return (
    <FluidCard
      advert={{
        title: title || `Caring for your ${genus.name || genus.botanicalName}`,
        url: `/aftercare/${genus.slug.current}`,
        image: genus.images?.[0]?.photos?.[0],
        cta: 'View care',
        theme: colorScheme,
        eyebrow: (
          <AftercareFullLogo
            wordMark={theme.colors.irisPurple}
            graphic={theme.colors.irisPurple}
            width={150}
            height={24.5}
          />
        ),
      }}
      loader="imagekit"
      openInNewTab
    />
  );
};
